// src/pages/RegisterPhonePage.jsx (senda nima deb tursa o‘sha faylga qo‘y)
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import uzFlag from "../assets/uzb.png";
import { IoHomeOutline } from "react-icons/io5";
import { useSendCodeMutation } from "../context/authApi";

export default function Register() {
  const [phone, setPhone] = useState("");
  const [error, setError] = useState("");
  const [sendCode, { isLoading }] = useSendCodeMutation();
  const navigate = useNavigate();

  const formatPhoneToFull = (raw) => {
    // faqat raqamlarni olib, +998 bilan birlashtiramiz
    const digits = raw.replace(/\D/g, "");
    return `+998${digits}`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!phone.trim()) {
      setError("Telefon raqamini kiriting.");
      return;
    }

    const digits = phone.replace(/\D/g, "");
    if (digits.length !== 9) {
      setError("Telefon raqamini to‘liq kiriting (9 ta raqam).");
      return;
    }

    const fullPhone = formatPhoneToFull(phone);

    try {
      await sendCode({ phone: fullPhone }).unwrap();
      // verify sahifaga to‘liq phone bilan o‘tamiz
      navigate("/verify", { state: { phone: fullPhone } });
    } catch (err) {
      console.error(err);
      setError(err?.data?.message || "Kod yuborishda xatolik yuz berdi.");
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center">
      {/* HEADER */}
      <div className="w-full flex justify-center pt-6 pb-4">
        <div className="flex items-center gap-2">
          <div className="h-8 w-8 rounded-full bg-black flex items-center justify-center text-white font-semibold text-lg">
            L
          </div>
          <span className="text-lg font-semibold text-gray-900">
            LiveQuiz.uz
          </span>
        </div>
      </div>

      {/* CARD */}
      <div className="max-w-md mx-auto bg-white shadow-xl rounded-2xl p-10 mt-2 border border-gray-100 w-full">
        {/* Bosh sahifa */}
        <div className="flex justify-end mb-4">
          <Link
            to="/"
            className="flex items-center gap-1 text-gray-500 text-sm"
          >
            <IoHomeOutline />
            Bosh sahifa
          </Link>
        </div>

        {/* Title */}
        <h1 className="text-center text-2xl font-bold text-gray-900">
          Telefon raqamini kiriting
        </h1>
        <p className="text-center text-gray-500 mt-2 text-sm">
          Sizning raqamingizga tasdiqlash kodi yuboramiz
        </p>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <div className="mt-6">
            <label className="text-sm font-medium text-gray-700">
              Telefon raqami *
            </label>
            <div className="flex items-center border rounded-lg mt-1 px-3 py-1">
              <img src={uzFlag} className="h-4 w-6 rounded-sm" />
              <span className="ml-2 text-gray-700">+998</span>
              <input
                type="tel"
                placeholder="XX XXX XX XX"
                className="ml-4 flex-1 outline-none border-none"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
            </div>
            <p className="text-xs text-gray-400 mt-1">
              Format: XX XXX XX XX
            </p>
          </div>

          {error && (
            <p className="mt-2 text-xs text-red-500 leading-snug">{error}</p>
          )}

          <button
            type="submit"
            disabled={isLoading}
            className="w-full bg-black text-white py-3 rounded-lg mt-6 flex items-center justify-center gap-2 hover:bg-gray-900 transition disabled:opacity-70"
          >
            {isLoading ? "Yuborilmoqda..." : "Davom etish"}
          </button>
        </form>

        {/* Terms */}
        <p className="text-center text-xs text-gray-500 mt-3">
          Davom etish orqali siz{" "}
          <button className="underline cursor-pointer">
            foydalanish shartlari
          </button>{" "}
          va{" "}
          <button className="underline cursor-pointer">
            maxfiylik siyosati
          </button>{" "}
          ga rozilik bildirasiz.
        </p>

        <hr className="my-5" />

        {/* Login link */}
        <p className="text-center text-gray-500 text-sm">Hisobingiz bormi?</p>
        <Link
          to="/login"
          className="w-full bg-transparent border text-black py-3 rounded-lg mt-3 flex items-center justify-center gap-2 hover:bg-gray-200 transition"
        >
          Kirish
        </Link>
      </div>

      {/* Footer */}
      <div className="text-center text-xs text-gray-400 mt-6 mb-6">
        © 2025 LiveQuiz.uz. Barcha huquqlar himoyalangan.
      </div>
    </div>
  );
}
